export default __webpack_public_path__ + "static/media/Mohit_Gulati.582839e1.svg";